import { Component, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NotificationService } from 'src/app/services/notification.service';
import { helper } from 'src/environments/helper';
import { CereriService } from '../../../cereri.service';
import Swal from 'sweetalert2';
import { finalize } from 'rxjs';

@Component({
    selector: 'app-update-generabil-valability',
    templateUrl: './update-generabil-valability.component.html',
    styleUrls: ['./update-generabil-valability.component.scss'],
})
export class UpdateGenerabilValabilityComponent {
    errorTitle: string = helper.dialogConfig.headers.errorAtentie;
    errorIcon: string = helper.dialogConfig.icons.error;
    errorType: string = helper.dialogConfig.icons.error;

    successTitle: string = helper.dialogConfig.headers.success;
    successIcon: string = helper.dialogConfig.icons.success;
    successType: string = helper.dialogConfig.icons.success;
    helper = helper;

    isLoading = false;
    form!: FormGroup;

    constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: number,
        private dialogRef: MatDialogRef<UpdateGenerabilValabilityComponent>,
        private fb: FormBuilder,
        private notificationService: NotificationService,
        private cereriService: CereriService
    ) { }

    ngOnInit(): void {
        this.buildForm();
    }
    specificDate = new Date(2024, 1, 27);
    buildForm() {
        this.form = this.fb.group({
            valability: [this.specificDate, Validators.required],
        });
    }

    closeDialog() {
        this.dialogRef?.close({
            success: false,
        });
    }

    addMonthsToValability(months: number) {
        const currentDate = this.form.get('valability')?.value || new Date();
        let newDate = new Date(currentDate);

        newDate.setMonth(newDate.getMonth() + months);

        let day = currentDate.getDate();
        while (newDate.getDate() !== day) {
            newDate.setDate(newDate.getDate() - 1);
        }

        this.form.patchValue({
            valability: newDate,
        });
    }

    submitRegistruValability() {
        const valabilityData = {
            valability: this.form.get('valability')?.value,
        };

        Swal.fire({
            title: this.helper.dialogConfig.commonTitles.areYouSure,
            text: 'Veți actualiza valabilitatea documentului. Continuați?',
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: this.helper.dialogConfig.buttonLabels.close,
            confirmButtonColor: this.helper.dialogConfig.colorButtons.standard,
            confirmButtonText: this.helper.dialogConfig.buttonLabels.confirm,
            showLoaderOnConfirm: true,
            reverseButtons: true,
            allowOutsideClick: false,
            preConfirm: () => {
                // This function will be called if the user confirms
                return this.cereriService
                    .editDocGenerabilValabilty(this.data, valabilityData)
                    .pipe(finalize(() => (this.isLoading = false)))
                    .toPromise();
            },
        })
            .then((result) => {
                if (result.isConfirmed && result.value) {
                    this.notificationService
                        .warningSwal(
                            this.successTitle,
                            'Document actualizat cu succes!',
                            this.successIcon
                        )
                        .then(() => {
                            this.dialogRef?.close({
                                success: true,
                            });
                        });
                }
            })
            .catch((error) => {
                let msg;
                try {
                    msg = error.error.errors.message[0];
                } catch (err) {
                    msg = this.helper.dialogConfig.generalMessages.error;
                }
                this.notificationService.warningSwal(
                    this.errorTitle,
                    msg,
                    this.errorIcon
                );
            });
    }
}
